import { UserToMentionDTO } from './dto/user-to-mention.dto';
import { MessageDTO } from './dto/message.dto';

export class ReplyUpdateModelBase {
    bccEmails: string[] = [];
    ccEmails: string[] = [];
    isCompleted: boolean;
    isDraft: boolean;
    isReplySentAsLink: boolean;
    isRecipientChangeConfirmed: boolean;
    message: MessageDTO;
    outboundEmailAddress?: string;
    parentId?: number;
    receiverEmail: string;
    senderEmail: string;
    senderName: string;
    socialMediaSourceId: number;
    suggestionId?: number;
    ticketId: number;
    toEmails: string[] = [];
    usersToMention: UserToMentionDTO[] = [];

    constructor(reply?, parentReplyId?, ccEmails?, toEmails?, bccEmails?, isNeedText = true) {
        this.message = new MessageDTO('', '');
        if (reply) {
            this.isDraft = reply.isDraft;
            this.usersToMention = reply.usersToMention;
            this.message = new MessageDTO(reply.message.html, isNeedText ? reply.message.text : null);
            this.isCompleted = false;
            this.parentId = parentReplyId;
            this.ccEmails = ccEmails;
            this.toEmails = toEmails;
            this.bccEmails = bccEmails;
            this.socialMediaSourceId = reply.socialMediaSourceId;
        }
    }
}
